<div class="dialog-overlay d-overlay">
  <div class="dialog" tabindex="-1">
    <div class="dialog-header">
      <div class="dialog-title">{{ title }}</div>
    </div>
    <div class="dialog-body" [innerHTML]="message"></div>
    <div class="dialog-footer">
      <button
        class="btn btn-outline-primary"
        (click)="Cancel()"
        (keydown.enter)="Cancel()"
      >
        {{ btnCancelText }}
      </button>
      <button
        class="btn btn-outline-primary"
        (click)="Confirm()"
        (keydown.enter)="Confirm()"
      >
        {{ btnOkText }}
      </button>
    </div>
  </div>
</div>
